import PropTypes from 'prop-types';
import cx from 'classnames';
import { ReactComponent as CheckIcon } from '../../../icons/check.svg';

import './ToggleChip.scss';

// A checkbox drawn as a pill, filled in its own colour while it's on
const ToggleChip = ({ name, label, checked, onChange, color = 'var(--primary-color)', disabled = false }) => (
  <label
    className={cx('ToggleChip', { 'is-on': checked, 'is-disabled': disabled })}
    style={{ '--chip-color': color }}
  >
    <input type="checkbox" name={name} checked={checked} onChange={onChange} disabled={disabled} />
    <span className="check" aria-hidden="true">
      <CheckIcon />
    </span>
    {label}
  </label>
);

ToggleChip.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ToggleChip;
